import React, { Component } from 'react';

import SearchProvider from '../../../../search-filter/components/search-container';
import SearchResults from '../../../../search-filter/components/search-results';
import Link from '../../../../shared/components/hyperlink';
import AdaptiveImage from '../../../../shared/components/adaptive-image';
import { withError } from '../../../../shared/components/error-boundary';
import withWindowResize from '../../../../ui/components/window-resize';
import { StoreAppAPI } from '../../../../core/src/storeapp-api-client';

import '../right-rail.less';


const storeAppAPI = new StoreAppAPI();

class PopularArticles extends Component {

  getLastThreeMonths = () => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    const numOfMonths = 12;

    let dateArr = [];
    for (let i = 0; i < 3; i++) {
      const yearAndMonth = currentMonth - i < 0 ? '' + (currentYear - 1) + (numOfMonths + (currentMonth - i)) : '' + (currentYear) + (currentMonth - i);
      dateArr.push(yearAndMonth);
    }

    return dateArr;

  }

  searchBlogs = (query, aggs, sort, from, size) => {
    //search for the top 10 articles
    const filters = { blogArchive: 'false', templateKey: 'blog', hosted: 'true', blogYearAndMonth: this.getLastThreeMonths() };
    sort = { "viewCount": "desc" };
    size = 10;
    const aggregates = {
      "all_years": "blogYear",
      "all_months": "blogMonth",
      "all_categories": "categories",
    };
    const aggregateFilters = Object.keys(aggregates);
    const bucketSize = 30;
    const post_filters = {};
    from = 0;
    return storeAppAPI.page.elasticSearch(filters, post_filters, aggregates, aggregateFilters, sort, size, from, bucketSize);
  }

  render() {
    const { device, width } = this.props;
    const showImage = (width && width > 767 && width < 1317) || device === 'tablet';

    return (
      <div className="popular-blogs">
        <h2 className="title">Popular articles</h2>
        <SearchProvider searchFunc={this.searchBlogs} searchKey='topBlogs'>
          <SearchResults element='ul' style={{ textAlign: "left" }}>
            {
              ({ results }) => {
                return results.map((blog, index) => {
                  const { blogTitle, blogThumbnail, vanityUrl } = blog._source;
                  if (blogTitle && blogThumbnail.src) {
                    return (
                      <li key={index} className={`popular-blog${index > 4 ? " tablet" : ""}`}>
                        <Link to={`${process.env.BASENAME}/${vanityUrl}`}>
                          {showImage && <AdaptiveImage
                            lazyload={true}
                            imageClassName="popular-blog-image"
                            src={blogThumbnail.src}
                            alt={blogThumbnail.alt}
                            title={blogThumbnail.title}
                            maxWidth={150}
                          />}
                          <div className={`popular-blog-title${(results.length > 5 && index === 4) || (index === results.length - 1) ? ' bottom-border-none' : ""}`}>
                            {blogTitle}
                          </div>
                        </Link>
                      </li>)
                  }
                });
              }
            }
          </SearchResults>
        </SearchProvider>
      </div>
    );
  }

}

export default withError(withWindowResize(PopularArticles));
